/*
 * @Description:
 * @Author: jiawei
 * @Date: 2025-07-24 11:23:41
 * @Last Modified by: jiawei
 * @Last Modified time: 2025-09-15 14:38:10
 */

import { includes, last, split } from 'lodash'
import qs from 'qs'

/**
 * 判断是否是余杭
 */
export const isYHSite = siteId => {
  if (window.RUN_CONFIG.env === 'prod') {
    return '1717431902413479936' === siteId
  }

  if (window.RUN_CONFIG.env === 'pre') {
    return false
  }

  if (window.RUN_CONFIG.env === 'sit') {
    return '1683291483228921856' === siteId
  }

  if (window.RUN_CONFIG.env === 'test') {
    return '1777258437902356480' === siteId
  }

  return false
}

export const SECOND_PAGE_TYPE = {
  NEW: 'new',
  MS: 'ms',
  SECOND: 'second',
  SECOND2: 'second2',
  SECOND3: 'second3',
}

/**
 * 处理链接
 */
export const getPageLink = (link, pageTitle) => {
  // 判断链接地址包含 #/topic/，就跳转到二级页面，可能会跳商品详情
  if (includes(link, '#/topic/')) {
    const parts = split(link, '#/topic/')
    const id = last(parts) || ''

    return `/secondPage?type=${SECOND_PAGE_TYPE['SECOND']}&id=${id}&title=${encodeURIComponent(pageTitle)}`
  }

  const queryStr = split(link, '?')[1] || ''
  const query = qs.parse(queryStr, { ignoreQueryPrefix: true })

  const id = query?.id || ''

  if (includes(link, '/pages/ProductScrollTwo/index')) {
    return `/secondPage?type=${SECOND_PAGE_TYPE['SECOND2']}&id=${id}&title=${encodeURIComponent(pageTitle)}`
  }

  if (includes(link, '/pages/SecondaryPageClassify2N/index')) {
    return `/secondPage?type=${SECOND_PAGE_TYPE['SECOND3']}&id=${id}&title=${encodeURIComponent(pageTitle)}`
  }

  return undefined
}

/**
 * 手动实现一个 Promise.allSettled
 * @param {*} promises
 * @returns Promise
 */
export function allSettled(promises) {
  return Promise.all(
    promises.map(p =>
      Promise.resolve(p).then(
        value => ({ status: 'fulfilled', value }),
        reason => ({ status: 'rejected', reason })
      )
    )
  )
}

/**
 * 判断是否是低版本浏览器
 * @returns boolean
 */
export function isLowLevelBrowser() {
  const ua = navigator.userAgent.toLowerCase()

  let name = 'unknown'
  let version = 0

  if (ua.includes('chrome') && ua.includes('edg/')) {
    name = 'edge'
    version = parseInt(ua.match(/edg\/(\d+)/)?.[1] || '0', 10)
  } else if (ua.includes('chrome')) {
    name = 'chrome'
    version = parseInt(ua.match(/chrome\/(\d+)/)?.[1] || '0', 10)
  } else if (ua.includes('firefox')) {
    name = 'firefox'
    version = parseInt(ua.match(/firefox\/(\d+)/)?.[1] || '0', 10)
  } else if (ua.includes('safari') && !ua.includes('chrome')) {
    name = 'safari'
    version = parseInt(ua.match(/version\/(\d+)/)?.[1] || '0', 10)
  }

  // 浏览器版本是根据Promise.finally 支持版本来决定的
  // 当浏览器版本低于Promise.finally 支持版本，就认为是低版本浏览器
  const supportedBrowsers = {
    chrome: 63,
    edge: 18,
    firefox: 58,
    safari: 11.1,
  }

  const thatVersion = supportedBrowsers[name]

  if (thatVersion && version < thatVersion) {
    return true
  }

  return false
}
